import * as React from 'react';
import { compose } from 'recompose';
import translate, { InjectedTranslateProps } from 'shared/utils/translate';

interface Props {}

type Enhanced = Props & InjectedTranslateProps;

const enhance = compose<Enhanced, Props>(translate);

export const Risks: React.FC<Enhanced> = ({ t }) => (
  <div className="invest-landing-section">
    <h2 className="invest-landing-section__title">{t('Risks')}</h2>
    <div className="invest-landing__content">
      <div className="invest-landing-dropdown__row">
        <div className="invest-landing-section__column invest-landing-section__column_col-16 invest-landing-section__column_gap-right-3">
          {t('Stocks risks paragraph')}
        </div>
      </div>
    </div>
  </div>
);

export default enhance(Risks);
